/* eslint-disable max-len */
import React, {
  useCallback, useContext, useEffect, useMemo, useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { Autocomplete, TextField } from '@mui/material';
import ListboxComponent from 'Shared/Header/AdapaterReactWindow';
import useForm from 'Shared/Hooks/hooks/useForm';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import axios from 'axios';
import { toast } from 'react-toastify';
import ReferencialContext from 'Shared/ReferencialContext';
import Trace from './Trace';
import { defaultMessage, getPropositionChange, getPropositions } from '../TraceabilityServices';
import PageActions from './PageActions';
import { setLoadingTrace } from '../traceabilitySlice';
import { PopperMy } from '../constants';

let cancelToken;
const PropositionTrace = () => {
  const {
    state: {
      referencial: { products },
    },
  } = useContext(ReferencialContext);
  const [isLast, setIsLast] = useState(false);
  const [page, setPage] = useState(0);
  const [traces, setTraces] = useState([]);
  const [shadows, setShadows] = useState([]);
  const dispatch = useDispatch();
  const { values, onChange } = useForm({ search: null, searchInput: '' });
  const [parentTraces, setParentTraces] = useState([]);

  const [propositionPage, setPropositionPage] = useState({ content: [] });
  const [matchProducts, setMatchProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleChange = (propery) => (e, value) => {
    onChange({ target: { name: propery, value } });
  };
  useEffect(async () => {
    try {
      dispatch(setLoadingTrace());
      const {
        changes, parents, page: currentPage, shadows: list,
      } = await getPropositionChange({
        page,
        id: values.search?.productId ? values.search.productId : values.search?.id,
        isProduct: !!values.search?.productId,
      });
      setShadows(list);
      if (changes.length === 0 && values?.search === null) {
        setIsLast(true);
      } else {
        setIsLast(false);
        setTraces(changes);
        setPage(currentPage);
        setParentTraces(parents);
      }
    } catch (error) {
      if (error.message === 'not found') {
        setTraces([]);
      }
    } finally {
      dispatch(setLoadingTrace());
    }
  }, [page, values.search, setShadows]);

  const getPropositionPage = useCallback(
    async () => {
      if (!values.searchInput) {
        return;
      }
      setLoading(true);
      try {
        if (typeof cancelToken !== typeof undefined) {
          cancelToken.cancel('Cancel');
        }
        cancelToken = axios.CancelToken.source();
        const data = await getPropositions(
          {
            size: 30,
            page: 0,
            name: values.searchInput,
            conf: { cancelToken: cancelToken.token },
          },
        );
        setMatchProducts(products?.filter((p) => p.reference?.toLowerCase()
          .includes(values.searchInput.toLowerCase())));
        setPropositionPage(data);
      } catch (e) {
        if (e.message !== 'Cancel') {
          const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
          toast.error(statusLabel);
        }
      } finally {
        setLoading(false);
      }
    },
    [products, values.searchInput],
  );

  useEffect(() => {
    getPropositionPage();
  }, [getPropositionPage]);

  const lines = useMemo(() => shadows.map((shadow) => ({ id: shadow.it.id, property: shadow.it.name })), [shadows]);
  return (
    <>
      {loading && <GlobalLoader size="100vh" />}

      <Autocomplete
        PopperComponent={PopperMy}
        // classes={{ root: classes.filter }}
        options={[...propositionPage?.content, ...matchProducts] || []}
        onChange={handleChange('search')}
        disablePortal
        value={values.search}
        size="small"
        onClick={(e) => { e.stopPropagation(); }}
        autoHighlight
        getOptionLabel={(option) => (!option.name ? `Product: ${option.reference}` : `Propostion: ${option.name}`)}
        ListboxComponent={ListboxComponent}
        filterOptions={(options) => options}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Rechercher"
            variant="outlined"
            name="searchInput"
            onChange={onChange}
            value={values.searchInput}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
          />
        )}
        popupIcon={<ExpandMoreIcon style={{ color: '#000' }} />}
      />
      <PageActions page={page} setPage={setPage} isLast={isLast} />
      {traces.map((trace) => (
        <Trace
          key={`key-trace-card-${trace.commitMetadata.id}`}
          changes={trace.changes}
          parents={parentTraces}
          commitMetadata={trace.commitMetadata}
          listShadows={trace.list}
          lines={lines}
          isDoc
        />
      ))}
    </>
  );
};

export default PropositionTrace;
